import { Link } from 'react-router-dom'
import {
  NorthernSkyRaidToolsLink,
  TimelineRemindersLink,
} from '../../../../../components/AddonLinks'

type Props = {
  eventsPath?: string
}

const TeamPlansIntro = ({ eventsPath }: Props) => {
  return (
    <p className='max-w-[60rem]'>
      On this page you can configure plans for encounter assignments and
      cooldown usages.{' '}
      {eventsPath ? (
        <span>
          Linking your plan to an{' '}
          <Link to={eventsPath} className='text-primary hover:text-primary/90'>
            event
          </Link>{' '}
          automatically assigns characters to it,
        </span>
      ) : (
        <span>
          You can import your current in-game raid setup using the{' '}
          <a
            href='https://www.curseforge.com/wow/addons/wowaudit-companion'
            target='_blank'
            rel='noopener noreferrer'
            className='text-primary hover:text-primary/90'
          >
            companion addon
          </a>
          ,
        </span>
      )}{' '}
      allowing you to export reminder notes for <TimelineRemindersLink /> or{' '}
      <NorthernSkyRaidToolsLink />.
    </p>
  )
}

export default TeamPlansIntro
